import { useAnimations, useGLTF } from "@react-three/drei";
import { useRef, useEffect } from "react";
import { useControls } from "leva";
import { useFrame } from "@react-three/fiber";
export default function Fishes() {

    const fish = useGLTF("../fish.draco.glb");
    const animations = useAnimations(fish.animations, fish.scene);

    // console.log(animations, 'fish ani');

    const sceneRef = useRef();
    

    // const { bFishAnimationName } = useControls({
    //     bFishAnimationName: {
    //         options: animations.names
    //     }
    // })

    // useEffect(() => {
    //     sceneRef.current.children.forEach(child => {
    //         console.log(child);
    //     });
    // }, []);

    useEffect(() => {
        const action1 = animations.actions['loop']
        action1.reset().fadeIn(0.5).play();

        const action2 = animations.actions['loop2']
        action2.reset().fadeIn(0.5).play();

        const action3 = animations.actions['loop3']
        action3.reset().fadeIn(0.5).play();

        const action4 = animations.actions['loop4']
        action4.reset().fadeIn(0.5).play();

        const action5 = animations.actions['loop5']
        action5.reset().fadeIn(0.5).play();

        return () =>
        {
            action1.fadeOut(0.5);
            action2.fadeOut(0.5);
            action3.fadeOut(0.5);
            action4.fadeOut(0.5);
            action5.fadeOut(0.5);
        }

    }, []);

    useFrame(({ clock }) => {
        if (!sceneRef) return;
        
        // 随时间变化形态键影响值
        const time = clock.getElapsedTime();
        const waveIntensity = Math.sin(time * 4);
        sceneRef.current.children.forEach(child => {
            if (child.morphTargetInfluences?.length > 0) {
                child.morphTargetInfluences[0] = waveIntensity;
            }
            if (child.children?.length > 0) {
                child.children.forEach(c => {
                    if (c.morphTargetInfluences?.length > 0) {
                        c.morphTargetInfluences[0] = waveIntensity;
                    }
                });
            }
        });
        
    });


    return <>
        <primitive
            ref={sceneRef}
            object={fish.scene}
            scale={0.1}
            position={[-2.5, 0, 2.5]}
            rotation-y={0.3}
        />
    </>;
}
